import { createAPI } from "../apisServer";
import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("cobranca");

const reqBoleto = {
	/**
	 * Rota de diagnostico do Servidor Cobranca.
	 * Gera uma remessa com convenio e titulo fixos, so para conferir
	 * que a geracao do arquivo funciona no ambiente.
	 *
	 * Remover quando a rota real de remessa estiver pronta.
	 */
	/**
	 * Quais das parcelas informadas ja possuem boleto ativo.
	 * Chamado apos cada busca para bloquear a linha antes da escolha.
	 */
	jaEmitidos: async function (idsContaEntrada) {
		return apiServer
			.post(
				"cobranca/v1/boleto/ja-emitidos",
				{ ids_conta_entrada: idsContaEntrada },
				{ headers: { banco: banco } },
			)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	remessaTeste: async function () {
		return apiServer
			.get("cobranca/v1/boleto/remessa-teste", {
				headers: { banco: banco },
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	/**
	 * Gera o arquivo de remessa das parcelas escolhidas.
	 */
	gerarRemessa: async function (idBoletoConfig, idsContaEntrada) {
		// Sem responseType blob de proposito: o CNAB e texto puro, e o
		// blob faria o axios tratar tambem o erro como binario - o
		// interceptor entregaria um Blob no lugar da mensagem.
		return apiServer
			.post(
				"cobranca/v1/boleto/remessa",
				{ id_boleto_config: idBoletoConfig, ids_conta_entrada: idsContaEntrada },
				{ headers: { banco: banco } },
			)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	libTeste: async function () {
		return apiServer.get("cobranca/v1/boleto/lib-teste");
	},

	engineTeste: async function () {
		return apiServer.get("cobranca/v1/boleto/engine-teste");
	},

	listarRemessas: async function (dtIni, dtFim) {
		return apiServer
			.get("cobranca/v1/boleto/remessas", {
				params: { dtini: dtIni, dtfim: dtFim },
				headers: { banco: banco },
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	regerarRemessa: async function (idBoletoConfig, numeroRemessa) {
		return apiServer
			.post(
				"cobranca/v1/boleto/regerar-remessa",
				{ id_boleto_config: idBoletoConfig, numero_remessa: numeroRemessa },
				{ headers: { banco: banco } },
			)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	/**
	 * PDF com todos os boletos de uma remessa ja emitida, num arquivo so.
	 * Os titulos sao recarregados com o Nosso Numero que foi gravado,
	 * entao o boleto impresso bate com o que foi para o banco.
	 */
	imprimirRemessa: async function (idBoletoConfig, numeroRemessa) {
		return apiServer
			.post(
				"cobranca/v1/boleto/pdf",
				{ id_boleto_config: idBoletoConfig, numero_remessa: numeroRemessa },
				{ headers: { banco: banco } },
			)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	/**
	 * Desativa os boletos de uma remessa que ainda nao foi confirmada pelo
	 * banco, soltando as parcelas para entrarem numa remessa nova.
	 * O servidor recusa se algum titulo ja teve retorno de registro ou
	 * pagamento - nesse caso a baixa tem que ser pedida ao banco.
	 */
	cancelarRemessa: async function (idBoletoConfig, numeroRemessa) {
		return apiServer
			.post(
				"cobranca/v1/boleto/cancelar-remessa",
				{ id_boleto_config: idBoletoConfig, numero_remessa: numeroRemessa },
				{ headers: { banco: banco } },
			)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	processarRetorno: async function (idBoletoConfig, arquivoConteudo) {
		return apiServer
			.post(
				"cobranca/v1/boleto/retorno",
				{ id_boleto_config: idBoletoConfig, arquivo: arquivoConteudo },
				{ headers: { banco: banco } },
			)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqBoleto;
